import apiChange from '../apiChange';

import { ParamsBodyPostQuotePlatform, ParamsDataPostQuoteListservices } from 'utils/typeServices';

type response = {
    success: boolean;
    message: string;
    errorCode: string;
    data: ParamsDataPostQuoteListservices;
}

export const PostQuotePlatform = async ({ body }: { body: ParamsBodyPostQuotePlatform }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeplatform/quotePlatform/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        if (data.data) {
            return data.data;
        } else {
            return data.message;
        }
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
